<script>
    import Icon from '../icons/Icon.svelte';

    export let mpSettings = {
        hasToken: false,
        hasClientSecret: false,
        mpAccessTokenMasked: '',
        mpClientId: '',
        mpClientSecretMasked: '',
        webhookUrl: '',
        redirectUri: ''
    };
    export let inputMpAccessToken = '';
    export let inputMpClientId = '';
    export let inputMpClientSecret = '';
    export let isSavingMp = false;
    export let isTestingMp = false;
    export let mpTestResult = null;
    export let onSaveMpSettings = () => {};
    export let onTestMpSettings = () => {};

    let showToken = false;
    let showSecret = false;
</script>

<div class="tab-pane">
    <section class="master-card">
        <div class="card-header">
            <div class="card-title-group">
                <Icon name="credit-card" size={20} />
                <h3>Gateway Mercado Pago do SaaS (Mensalidades)</h3>
            </div>
            <span class="card-subtitle">Credenciais da conta Mercado Pago do administrador do sistema, utilizadas para cobrança de mensalidades e autenticação OAuth dos restaurantes via Connect.</span>
        </div>

        <div class="form-grid">
            <!-- Access Token -->
            <div class="form-group full-width">
                <div class="label-row">
                    <label for="mp-token-input">Mercado Pago Access Token (Produção)</label>
                    {#if mpSettings.hasToken}
                        <span class="status-pill configured">● Configurado ({mpSettings.mpAccessTokenMasked})</span>
                    {:else}
                        <span class="status-pill missing">● Ausente</span>
                    {/if}
                </div>
                <div class="input-toggle-box">
                    {#if showToken}
                        <input
                            id="mp-token-input"
                            type="text"
                            bind:value={inputMpAccessToken}
                            placeholder={mpSettings.hasToken ? 'Token gravado (digite para atualizar)' : 'APP_USR-...'}
                            class="form-input"
                        />
                    {:else}
                        <input
                            id="mp-token-input"
                            type="password"
                            bind:value={inputMpAccessToken}
                            placeholder={mpSettings.hasToken ? 'Token gravado (digite para atualizar)' : 'APP_USR-...'}
                            class="form-input"
                        />
                    {/if}
                    <button type="button" class="btn-toggle" on:click={() => showToken = !showToken} aria-label="Alternar visibilidade do token">
                        <Icon name={showToken ? 'eye-off' : 'eye'} size={14} />
                    </button>
                </div>
            </div>

            <!-- Client ID -->
            <div class="form-group">
                <label for="mp-client-id">Client ID da Aplicação</label>
                <input
                    id="mp-client-id"
                    type="text"
                    bind:value={inputMpClientId}
                    placeholder={mpSettings.mpClientId || 'Ex: 1234567890123456'}
                    class="form-input"
                />
            </div>

            <!-- Client Secret -->
            <div class="form-group">
                <div class="label-row">
                    <label for="mp-client-secret">Client Secret da Aplicação</label>
                    {#if mpSettings.hasClientSecret}
                        <span class="status-pill configured">● Gravado</span>
                    {/if}
                </div>
                <div class="input-toggle-box">
                    {#if showSecret}
                        <input
                            id="mp-client-secret"
                            type="text"
                            bind:value={inputMpClientSecret}
                            placeholder={mpSettings.hasClientSecret ? '••••••••••••••••' : 'Client Secret'}
                            class="form-input"
                        />
                    {:else}
                        <input
                            id="mp-client-secret"
                            type="password"
                            bind:value={inputMpClientSecret}
                            placeholder={mpSettings.hasClientSecret ? '••••••••••••••••' : 'Client Secret'}
                            class="form-input"
                        />
                    {/if}
                    <button type="button" class="btn-toggle" on:click={() => showSecret = !showSecret} aria-label="Alternar visibilidade da credencial">
                        <Icon name={showSecret ? 'eye-off' : 'eye'} size={14} />
                    </button>
                </div>
            </div>
        </div>

        <!-- URLs de Callback / Webhooks do SaaS -->
        <div class="callbacks-box">
            <h4>Endpoints de Integração do Mercado Pago</h4>
            <div class="callback-item">
                <span class="cb-label">URL de Webhook (IPN / Pagamentos):</span>
                <code class="cb-code">{mpSettings.webhookUrl || 'https://sua-api.com/api/saas/webhooks/mercadopago'}</code>
            </div>
            <div class="callback-item">
                <span class="cb-label">Redirect URI (OAuth Connect dos Restaurantes):</span>
                <code class="cb-code">{mpSettings.redirectUri || 'https://sua-api.com/api/saas/mercadopago/oauth-callback'}</code>
            </div>
        </div>

        {#if mpTestResult}
            <div class="test-feedback-box {mpTestResult.success ? 'success' : 'error'}">
                <Icon name={mpTestResult.success ? 'check-circle' : 'alert-triangle'} size={14} />
                <span>{mpTestResult.message || (mpTestResult.success ? 'Credenciais validadas com sucesso!' : 'Falha na validação.')}</span>
            </div>
        {/if}

        <div class="card-footer">
            <button
                type="button"
                class="btn-test-mp"
                disabled={isTestingMp || (!inputMpAccessToken && !mpSettings.hasToken)}
                on:click={onTestMpSettings}
            >
                <Icon name="zap" size={14} />
                <span>{isTestingMp ? 'Testando credenciais...' : 'Testar Conexão MP'}</span>
            </button>

            <button
                type="button"
                class="btn-save-master"
                disabled={isSavingMp}
                on:click={onSaveMpSettings}
            >
                <Icon name="check" size={15} />
                <span>{isSavingMp ? 'Salvando...' : 'Salvar Configurações de Gateway'}</span>
            </button>
        </div>
    </section>
</div>

<style>
    .tab-pane {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .master-card {
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 12px;
        padding: 24px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
    }

    .card-header {
        margin-bottom: 20px;
    }

    .card-title-group {
        display: flex;
        align-items: center;
        gap: 10px;
        color: #0F172A;
    }

    .card-title-group h3 {
        font-size: 16px;
        font-weight: 700;
        margin: 0;
        color: #0F172A;
    }

    .card-subtitle {
        font-size: 13px;
        color: #64748B;
        display: block;
        margin-top: 4px;
        line-height: 1.4;
    }

    .form-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
        gap: 16px;
        margin-bottom: 22px;
    }

    .full-width {
        grid-column: 1 / -1;
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .label-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .form-group label {
        font-size: 12px;
        font-weight: 600;
        color: #475569;
    }

    .status-pill {
        font-size: 11px;
        font-weight: 700;
        padding: 2px 8px;
        border-radius: 4px;
    }

    .status-pill.configured {
        background: #DCFCE7;
        color: #166534;
        border: 1px solid #BBF7D0;
    }

    .status-pill.missing {
        background: #F1F5F9;
        color: #64748B;
        border: 1px solid #E2E8F0;
    }

    .input-toggle-box {
        position: relative;
        display: flex;
        align-items: center;
    }

    .form-input {
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        border-radius: 8px;
        padding: 10px 38px 10px 14px;
        color: #0F172A;
        font-family: monospace;
        font-size: 13px;
        width: 100%;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
        transition: border-color 0.2s, box-shadow 0.2s;
    }

    .form-input:focus {
        outline: none;
        border-color: #FF6A00;
        box-shadow: 0 0 0 2px rgba(255, 106, 0, 0.15);
    }

    .btn-toggle {
        position: absolute;
        right: 8px;
        background: none;
        border: none;
        color: #94A3B8;
        cursor: pointer;
        padding: 4px;
        display: flex;
    }

    .btn-toggle:hover {
        color: #0F172A;
    }

    .callbacks-box {
        background: #F8FAFC;
        border: 1px solid #E2E8F0;
        border-left: 3px solid #FF6A00;
        border-radius: 10px;
        padding: 16px 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 20px;
    }

    .callbacks-box h4 {
        font-size: 12px;
        font-weight: 700;
        color: #FF6A00;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin: 0;
    }

    .callback-item {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .cb-label {
        font-size: 12px;
        color: #64748B;
    }

    .cb-code {
        font-family: monospace;
        font-size: 12px;
        background: #F1F5F9;
        border: 1px solid #E2E8F0;
        padding: 6px 10px;
        border-radius: 6px;
        color: #0F172A;
        word-break: break-all;
    }

    .test-feedback-box {
        padding: 10px 14px;
        border-radius: 8px;
        font-size: 13px;
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 18px;
    }

    .test-feedback-box.success {
        background: #DCFCE7;
        color: #166534;
        border: 1px solid #BBF7D0;
    }

    .test-feedback-box.error {
        background: #FEE2E2;
        color: #991B1B;
        border: 1px solid #FECACA;
    }

    .card-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        border-top: 1px solid #E2E8F0;
        padding-top: 18px;
        flex-wrap: wrap;
    }

    .btn-test-mp {
        background: #F8FAFC;
        border: 1px solid #CBD5E1;
        color: #475569;
        padding: 9px 18px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        transition: all 0.15s ease;
    }

    .btn-test-mp:hover:not(:disabled) {
        background: #F1F5F9;
        color: #0F172A;
        border-color: #94A3B8;
    }

    .btn-test-mp:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .btn-save-master {
        background: #FF6A00;
        border: 1px solid #EA580C;
        color: #FFFFFF;
        padding: 9px 22px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        box-shadow: 0 1px 3px rgba(255, 106, 0, 0.2);
        transition: all 0.15s ease;
    }

    .btn-save-master:hover:not(:disabled) {
        background: #EA580C;
        box-shadow: 0 3px 8px rgba(255, 106, 0, 0.3);
    }

    .btn-save-master:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
</style>
